<ion-row [class.disabled]="!canPlay" (click)="canPlay && playVideo(item.ID)">
  <ion-col size="3" class="imageContainer">
    <ion-img src="./assets/images/middle/{{ item.IMAGE }}"></ion-img>
  </ion-col>

  <ion-col size="9" class="labelContainer ion-flex-center-center">
    <ion-img class="redCorner" src="./assets/images/red_corner.png"></ion-img>

    <ion-label>{{ itemLabel }}</ion-label>
  </ion-col>
</ion-row>
